import React, {useEffect, useState} from 'react';
import {TeamProps} from "./Team.props";
import {LearnersOverview} from "../LearnersOverview";
import {useLocation} from "react-router-dom";
import ChangeWorkSpace from "../../hoc/changeWorkSpace";

const TeamComponent : React.FC<TeamProps> = () => {
  const { state } = useLocation();
  const [subTabIndex, setSubTabIndex] = useState<number>(0);

  useEffect(() => {
    if (state !== null) {
      setSubTabIndex(state.subTabIndex);
    }
  }, [state]);

  return (
    <>
      <LearnersOverview
        subTabIndex={subTabIndex}
        setSubTabIndex={setSubTabIndex}
      />
    </>
  );
};

export const Team = ChangeWorkSpace(TeamComponent);
